import { useCreateKommunikation } from '@/hooks/useCreateKommunikation';
import { usePatchKommunikation } from '@/hooks/usePatchKommunikation';
import { KommunikationFormular } from './KommunikationFormular';
import { KommunikationEintrag } from './KommunikationEintrag';
import type { Bestellung } from '@/types/detail';

export function KommunikationSektion({
  anker,
  bestellung
}: {
  /** data-tour-Name fuer die Einfuehrungstour. */
  anker?: string;
  bestellung: Bestellung;
}) {
  const create = useCreateKommunikation(bestellung.bestellnr);
  const patch = usePatchKommunikation(bestellung.bestellnr);

  return (
    <section className="space-y-3" data-tour={anker}>
      <h3 className="font-serif text-base text-ink">Kommunikation</h3>
      <KommunikationFormular
        bestellungId={bestellung.id}
        isPending={create.isPending}
        // mutateAsync, damit das Formular erst nach bestaetigtem Erfolg
        // geleert und der Entwurf verworfen wird (S-1).
        onSubmit={async (req) => {
          await create.mutateAsync({ ...req, bestellung_id: bestellung.id });
        }}
      />
      {bestellung.kommunikation.length === 0 ? (
        <p className="rounded-md border border-dashed border-line bg-cream-warm px-3 py-4 text-center text-sm text-ink-faint">
          Noch keine Einträge.
        </p>
      ) : (
        <div className="space-y-2">
          {bestellung.kommunikation.map((e) => (
            <KommunikationEintrag
              key={e.id}
              eintrag={e}
              onUpdate={(id, freitext) => patch.mutate({ id, freitext })}
            />
          ))}
        </div>
      )}
    </section>
  );
}
